import { BrandPageProps } from 'src/pages/BrandPage/index'
import React from 'react'
import { Container } from 'src/components/common/Container'
import styled, { css } from 'styled-components'
import { layoutMaxSize } from 'src/styles/mixin'
import UnderLineTab from 'src/components/common/UnderLineTab'
import OnSaleCoupon from 'src/pages/BrandPage/_components/OnSaleCoupon'
import OnPossessionCoupon from 'src/pages/BrandPage/_components/OnPossessionCoupon'
import { UnderLineType, useGlobalStore } from 'src/store/zustand'

type BrandUnderLineTabType = 0 | 1

const BrandPageView = (props: BrandPageProps) => {
  const { possessionCouponCnt } = props
  const { brandUnderLineTab, setBrandUnderLineTab } = useGlobalStore()
  const handleChangeUnderLine = (value: UnderLineType) => setBrandUnderLineTab(value)

  return (
    <S.BrandPageContainer $option="flex_column">
      <S.BrandPageWrap $option="flex_column">
        <UnderLineTab<BrandUnderLineTabType>
          items={[
            { text: '판매 중', contents: <OnSaleCoupon {...props} />, value: 0 },
            {
              text: `보유 중(${possessionCouponCnt})`,
              contents: <OnPossessionCoupon {...props} />,
              value: 1,
            },
          ]}
          state={{ activeTab: brandUnderLineTab, setActiveTab: handleChangeUnderLine }}
          style={S.BrandUnderlineTabStyle}
        />
      </S.BrandPageWrap>
    </S.BrandPageContainer>
  )
}
export default BrandPageView

const S = {
  BrandPageContainer: styled(Container)`
    ${layoutMaxSize};
    width: 100%;
    flex: 1;
  `,
  BrandPageWrap: styled(Container)`
    gap: 10px;
    margin: 0 auto;
    flex: 1;
  `,
  EmptyBrandItemsWrap: styled(Container)`
    justify-content: center;
    text-align: center;
    height: 300px;
  `,
  BrandUnderlineTabStyle: css`
    width: calc(100% - 40px);
    margin: 0 auto;
  `,
}
